import React, { useEffect, useState } from 'react';
import { DeleteRequest, GetRequest, PutRequest } from '../../../../Utils/hooks/ApiHandler';
import useLocalStorageState from 'use-local-storage-state';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    IconCalendarEvent, IconClock, IconUser,
    IconAlertCircle, IconPhone, IconMail, IconChecklist,
    IconEdit,
    IconDotsVertical,
    IconTrash,
    IconBolt,
    IconFlag,
    IconCategory,
    IconUserCircle,
    IconCalendar,
    IconBriefcase,
    IconCircle
} from '@tabler/icons-react';
import { Badge, Row, Col, Dropdown, Form } from 'react-bootstrap';
import { formatDate, getValueOrDash, navigateToCrmDetail } from '../../../../Utils/helpers/commonhelper';
import { toast } from 'sonner';
import { FaEllipsisV, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { customStyles } from "../../../../Utils/helpers/commonhelper"
import { Tasks } from '../../../Forms/Tasks';
import DeleteModal from '../../../DeleteModal';

export const ContactTaskDetallsCard = ({ taskId, owner_id, contactId, taskEditGrant, taskDeleteGrant }) => {
    const [customer, setCustomer] = useLocalStorageState('customer');
    const navigate = useNavigate();
    const location = useLocation();

    const userLoginId = customer?.customer_details?.id;
    const headers = {
        Authorization: customer?.token?.authorization || "",
        Authentication: customer?.token?.authentication || "",
    };
    const extras = { customer, setCustomer, rf: customer?.token?.authentication, navigate };
    const STATUS_OPTIONS = [
        { value: "open", label: "Open" },
        { value: "inprogress", label: "Inprogress" },
        { value: "cancelled", label: "Cancelled" },
        { value: "completed", label: "Completed" },
    ];
    const [taskData, setTaskData] = useState(null);
    // state for opening offcavs for edit task
    const [openEditTaskCanvas, setOpenEditTaskCanvas] = useState(false)
    // state for delete a task
    const [deleteTask, setDeleteTask] = useState(false)
    const [loading, setLoading] = useState(false);

    const fetchTask = async () => {
        setLoading(true);
        try {
            const res = await GetRequest(
                `contacts/getTaskDetailsForEdit/${taskId}`,
                { headers },
                extras
            );
            if (res.status === 'fail' || res.success === false) {
                toast.error(res.message)
                setLoading(false)
                return
            }
            const row = res?.data?.[0]
            let contactPhone = getValueOrDash(row?.contact_phone)
            if (row?.user_phone) {
                try {
                    const parsedContactInfo = JSON.parse(row.user_phone)
                    const countryCode = parsedContactInfo?.[0]?.country_code
                    if (countryCode != null) {
                        const phone = parsedContactInfo?.[0]?.phone ?? row?.contact_phone
                        contactPhone = phone != null ? `+${countryCode} ${phone}` : getValueOrDash(row?.contact_phone)
                    }
                } catch {
                    contactPhone = getValueOrDash(row?.contact_phone)
                }
            }
            setTaskData({
                ...row,
                contact_phone: contactPhone
            });
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!taskId) return;
        fetchTask();
    }, [taskId]);

    if (!taskId) {
        return (
            <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-5 border rounded-3 bg-light-subtle" style={{ borderStyle: 'dashed !important' }}>
                <IconChecklist size={48} stroke={1} className="mb-3 opacity-50" />
                <p className="fw-medium">Select a task from the list to view details</p>
            </div>
        );
    }

    // handle delete task
    const handleDeleteTask = async () => {
        setLoading(true)
        try {
            const res = await DeleteRequest(
                `contacts/deleteTask/${taskId}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
                { headers },
                extras
            );
            setLoading(false)
            await fetchTask();
            // (false);
        } catch (error) {
            setLoading(false)
        }
    };

    const onFormSubmit = async (taskStatus) => {
        try {

            const editPayload = {
                task_id: taskId,
                // module_name: "contact",
                name: taskData.name,
                type: taskData.type,
                description: taskData.description,
                task_status: taskStatus,
                priority: taskData.priority,
                due_date: taskData.due_date,
                due_time: taskData.due_time,
                reminder: taskData.reminder,
                assigned_to: taskData.assigned_to || owner_id,
                user_login_id: userLoginId,
            }
            const res = await PutRequest(
                `contacts/updateTask`,
                editPayload,
                { headers },
                extras
            );
            if (res.status === "fail" || res.success === false) {
                setLoading(false)
                return
            }
            toast.success(res.message)
        } catch (error) {
            return
        }
    };


    const getPriorityColor = (p) => {
        const colors = { high: '#ef4444', medium: '#f59e0b', low: '#10b981' };
        return colors[p?.toLowerCase()] || '#64748b';
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "medium":
                return "text-warning"
            case "low":
                return "text-primary"
            case "high":
                return "text-danger"
            default:
                return "bg-secondary"
        }
    }

    // skeleton loader until task is fetched
    if (loading) {
        return <TaskSkeleton />
    }
    return (
        <>
            <div className="h-100 bg-white rounded-3 overflow-hidden d-flex flex-column" >

                <div className=" py-2 pb-2 d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid #e0e4f8' }}>
                    <div className="d-flex align-items-start gap-1 text-muted">
                        <IconChecklist size={20} stroke={2} style={{ marginTop: "0.8px" }} color="black" />
                        <span className="card-header mb-0" style={{ fontWeight: 400, fontSize: '16px', }}>
                            Task Details
                        </span>
                    </div>
                    <Dropdown style={{ zIndex: 99 }}>
                        <Dropdown.Toggle
                            as="div"
                            style={{
                                cursor: "pointer",
                                color: "#6c757d",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                            }}
                            className="no-arrow"
                        >
                            <FaEllipsisV size={14} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                className=' d-flex align-items-center gap-2'
                                onClick={() => {
                                    if (!taskEditGrant) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setOpenEditTaskCanvas(true);
                                }}
                            >
                                <IconEdit size={14} />
                                Edit
                            </Dropdown.Item>

                            <Dropdown.Item
                                className="text-danger d-flex align-items-center gap-2"
                                onClick={() => {
                                    if (!taskDeleteGrant) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setDeleteTask(true);
                                }}
                            >
                                <IconTrash size={14} />
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="pr-0 ps-4 py-4 flex-grow-1 overflow-auto">
                    <div className="d-flex align-items-center justify-content-between w-100  mb-4">
                        <div>
                            {/* <h3 className="fw-bold text-dark mb-1" style={{ fontSize: '1.6rem', letterSpacing: '-0.01em' }}> */}
                            <h3 className="mt-0 mb-2" style={{ fontSize: "1.2rem", fontWeight: 400 }}>
                                {getValueOrDash(taskData?.name)}
                            </h3>
                            <div className="d-flex align-items-center gap-2">
                                <div
                                    style={{
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        background: taskData?.task_status === 'open' ? '#10b981' : '#94a3b8'
                                    }}
                                />
                                <span className="d-flex align-items-center gap-1 fw-bold text-muted text-uppercase" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                                    Status: <span style={{ color: taskData?.task_status === 'open' ? '#10b981' : '#64748b' }}>
                                        {taskData?.task_status || 'N/A'}
                                    </span>
                                </span>
                            </div>

                        </div>
                        <div className="w-25 align-self-end" style={{ zIndex: 99, maxWidth: '100%' }}>
                            <Form.Group className='form-z-index position-relative'>
                                <span
                                    className="mb-2 "
                                    style={{
                                        position: 'absolute',
                                        zIndex: 99,
                                        left: '5%',
                                        top: 5,
                                        fontSize: "11px",
                                        fontWeight: 500,
                                        color: "#64748b",
                                    }}
                                >
                                    Update Task Status
                                </span>

                                <Select
                                    options={STATUS_OPTIONS}
                                    value={STATUS_OPTIONS.find(
                                        (status) => status.value === taskData?.task_status
                                    )}
                                    onChange={(selectedOption) => {
                                        setTaskData((prev) => ({
                                            ...prev,
                                            task_status: selectedOption?.value,
                                        }))
                                        onFormSubmit(selectedOption?.value)
                                    }}
                                    classNamePrefix="react-select"

                                    menuPosition="fixed"
                                    styles={customStyles}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <>
                        <Row className="g-4">
                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconUser size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Assigned To"
                                    value={getValueOrDash(taskData?.assign_name)}
                                />
                            </Col>

                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconBriefcase size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Task Type"
                                    value={getValueOrDash(taskData?.type)}
                                />
                            </Col>

                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconUserCircle size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Contact Name"
                                    valueClassName='text-capitalize '
                                    handler={() => {
                                        if (contactId == null) return
                                        window.open(`/contactDetails?currContactId=${contactId}`, '_blank')
                                    }}
                                    value={getValueOrDash(taskData?.contact_name)}
                                />
                            </Col>

                            {/* 2nd row */}
                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconCalendar size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Due Date"
                                    value={formatDate(getValueOrDash(taskData?.due_date))}
                                />
                            </Col>

                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconClock size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Due Time"
                                    value={getValueOrDash(taskData?.due_time)}
                                />
                            </Col>

                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconMail size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Contact Email"
                                    value={getValueOrDash(taskData?.email)}
                                />
                            </Col>

                            {/* 3rd row */}
                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconClock size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Reminder"
                                    value={getValueOrDash(taskData?.reminder)}
                                />
                            </Col>

                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconFlag size={20} color={'#64748b'} stroke={1.5} />}
                                    label="Priority"
                                    value={getValueOrDash(taskData?.priority)}
                                    valueClassName={getStatusColor(taskData?.priority)}
                                    textTransform="capitalize"
                                />
                            </Col>


                            <Col md={4}>
                                <TaskInfoRow
                                    icon={<IconPhone size={20} className="text-muted" stroke={1.5} style={{ marginTop: "0.2rem" }} />}
                                    label="Contact Phone"
                                    value={getValueOrDash(taskData?.contact_phone)}
                                />
                            </Col>
                        </Row>
                    </>
                    <hr />
                    <div className="description-wrap mt-4">
                        <label style={labelStyle} className="mb-2">Description</label>
                        <p className="text-secondary fs-14" style={{ lineHeight: '1.6', whiteSpace: 'pre-line' }}>
                            {getValueOrDash(taskData?.description)}
                        </p>
                    </div>
                </div>

                <style>{`
                .edit-btn-hover:hover {
                    background-color: #7a3a5e !important;
                    color: white !important;
                    transform: scale(1.05);
                }
                .transition-all {
                    transition: all 0.2s ease-in-out;
                }
            `}</style>
            </div >
            {openEditTaskCanvas && owner_id && (contactId !== undefined || contactId !== null) && (
                <Tasks
                    ownerId={owner_id}
                    show={openEditTaskCanvas}
                    onCanvasClose={() => setOpenEditTaskCanvas(false)}
                    taskId={taskId}
                    editTask={openEditTaskCanvas}
                    contactId={contactId}
                    fetchAllTasks={fetchTask}
                />)
            }

            {
                deleteTask && (
                    <DeleteModal
                        onConfirm={handleDeleteTask}
                        show={deleteTask}
                        onClose={() => setDeleteTask(false)}
                        isLoading={loading}
                        message={"Are you sure you want to delete this task?"}
                    />
                )
            }
        </>
    );
};

const TaskInfoRow = ({
    icon,
    label,
    value,
    // optional, only mandatory for contact name
    handler,
    valueClassName = "",
    textTransform = "none"
}) => {
    const lowerCaseLabel = label?.toLowerCase()?.split(" ")?.join("_")
    return <div className="d-flex align-items-start gap-2 overflow-hidden">
        <div
            className="d-flex align-items-center justify-content-center rounded-full"
            style={{
                backgroundColor: "#f1f5f9",
                borderRadius: "50%",
                minWidth: "32px",
                height: "32px",
                color: "#2656a8",
                marginRight: '4px'
            }}
        >
            {icon}
        </div>
        <div className="overflow-hidden">
            <span className="mb-0" style={{ ...labelStyle }}>
                {label}
            </span>
            <span
                className={`mb-0 text-truncate ${valueClassName}`}
                style={{
                    color: lowerCaseLabel === "contact_name" && "#0099ff",
                    fontSize: "14px",
                    cursor: "pointer",
                    fontWeight: 400,
                    textTransform,
                }}
                onClick={handler}
            >
                {value}
            </span>
        </div>
    </div>
}

const TaskSkeleton = () => {
    return (
        <div className="h-100 bg-white rounded-3 overflow-hidden d-flex flex-column">

            {/* Header */}
            <div
                className="py-2 pb-2 d-flex justify-content-between align-items-center"
                style={{ borderBottom: '1px solid #e0e4f8' }}
            >
                <div className="d-flex align-items-center gap-1">

                    <span
                        className="rounded-circle"
                        style={{
                            width: 20,
                            height: 20,
                            background: "#e0e0e0"
                        }}
                    />

                    <span
                        style={{
                            width: 110,
                            height: 14,
                            borderRadius: 4,
                            background: "#f0f0f0",
                            display: "block"
                        }}
                    />
                </div>

                <span
                    className="rounded-circle"
                    style={{
                        width: 20,
                        height: 20,
                        background: "#e0e0e0"
                    }}
                />
            </div>

            {/* Body */}
            <div className="p-4 flex-grow-1 overflow-auto">

                {/* Title */}
                <div className="mb-4">

                    <div
                        className="mb-3"
                        style={{
                            width: "45%",
                            height: 28,
                            borderRadius: 6,
                            background: "#e0e0e0"
                        }}
                    />

                    <div className="d-flex align-items-center gap-2">

                        <span
                            className="rounded-circle"
                            style={{
                                width: 8,
                                height: 8,
                                background: "#e0e0e0"
                            }}
                        />

                        <span
                            style={{
                                width: 120,
                                height: 12,
                                borderRadius: 4,
                                background: "#f0f0f0",
                                display: "block"
                            }}
                        />
                    </div>
                </div>

                {/* Info Rows */}
                <Row className="g-4">
                    {[...Array(6)].map((_, index) => (
                        <Col md={6} key={index}>
                            <div className="d-flex align-items-start gap-2">

                                <span
                                    className="rounded-circle flex-shrink-0"
                                    style={{
                                        width: 20,
                                        height: 20,
                                        background: "#e0e0e0"
                                    }}
                                />

                                <div className="w-100">

                                    <div
                                        className="mb-2"
                                        style={{
                                            width: "35%",
                                            height: 10,
                                            borderRadius: 4,
                                            background: "#f0f0f0"
                                        }}
                                    />

                                    <div
                                        style={{
                                            width: "70%",
                                            height: 14,
                                            borderRadius: 4,
                                            background: "#f5f5f5"
                                        }}
                                    />
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

                <hr />

                {/* Description */}
                <div className="description-wrap mt-4">

                    <div
                        className="mb-3"
                        style={{
                            width: 90,
                            height: 12,
                            borderRadius: 4,
                            background: "#e0e0e0"
                        }}
                    />

                    <div
                        className="w-100 mb-2"
                        style={{
                            height: 12,
                            background: "#f0f0f0",
                            borderRadius: 4
                        }}
                    />

                    <div
                        className="w-75 mb-2"
                        style={{
                            height: 12,
                            background: "#f5f5f5",
                            borderRadius: 4
                        }}
                    />

                    <div
                        className="w-50"
                        style={{
                            height: 12,
                            background: "#f7f7f7",
                            borderRadius: 4
                        }}
                    />
                </div>
            </div>

            {/* Footer */}
            <div className="pb-4 form-container w-100 d-flex justify-content-end">

                <div className="w-50">

                    <div
                        className="mb-2"
                        style={{
                            width: 130,
                            height: 12,
                            borderRadius: 4,
                            background: "#e0e0e0"
                        }}
                    />

                    <div
                        className="w-100"
                        style={{
                            height: 38,
                            borderRadius: 6,
                            background: "#f0f0f0"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
const labelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};